import { BaseContainerModel } from "../base-container.model";
import {
  bl_mkp_mst_pricing_scheme_link_Rowinterface,
  bl_mkp_mst_pricing_scheme_link_Rowclass,
} from "../../dbschema/index";

export class MkpPricingSchemeLinkContainer extends BaseContainerModel {
  bl_mkp_mst_pricing_scheme_link: bl_mkp_mst_pricing_scheme_link_Rowinterface =
    new bl_mkp_mst_pricing_scheme_link_Rowclass();
}
